import Swiper, { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import 'swiper/css/navigation';

//トップページ
export function homeFunc() {
  /**
   * NEWSタブ切り替え
   */
  const newsTab = document.querySelectorAll( '.p-home-news__tab' );
  const newsArchive = document.querySelectorAll( '.p-home-news__item' );
  const newsButton = document.querySelector( '.p-home-news__button a' );
  const newURL = 'https://www.fujielectric.co.jp/fsl/news/2023/index.html';
  const seminarURL = 'https://www.fujielectric.co.jp/fsl/seminar/2023/index.html';

  newsArchive.forEach( newsItem => {
    const category = newsItem.getAttribute( 'data-cat' );
    if ( category === 'news' ) {
      $( newsItem ).show();
    }
  } );

  newsTab.forEach( newsTabItem => {
    newsTabItem.addEventListener( 'click', function () {
      const tabId = this.getAttribute( 'id' );

      if ( tabId === 'news' ) {
        newsButton.setAttribute( 'href', newURL );
      }
      if ( tabId === 'seminar' ) {
        newsButton.setAttribute( 'href', seminarURL );
      }

      newsArchive.forEach( newsItem => {
        const category = newsItem.getAttribute( 'data-cat' );
        if ( category === tabId ) {
          $( newsItem ).show();
        } else {
          $( newsItem ).hide();
        }
      } );

      newsTab.forEach( newsTabItem => {
        newsTabItem.classList.remove( 'p-home-news__tab--active' );
      } );
      this.classList.add( 'p-home-news__tab--active' );
    } );
  } );

  /**
   * MVスライダー
   */
  Swiper.use( [ Autoplay, Navigation, Pagination ] );
  const mvSwiper = new Swiper( '.p-home-mv__container', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: '.p-home-mv__next',
      prevEl: '.p-home-mv__prev'
    },
    pagination: {
      el: '.p-home-mv__pagination',
      clickable: true
    },
    watchSlidesProgress: true,
    keyboard: {
      enabled: true,
    },
    a11y: {
      enabled: false,
    },
  } );

  // p-home-mv__stopをクリックで、mvSwiperの自動再生を停止
  const mvStop = document.querySelector( '.p-home-mv__stop' );
  mvStop.addEventListener( 'click', () => {
    if ( mvSwiper.autoplay.running ) {
      mvSwiper.autoplay.stop();
      mvStop.classList.add( 'is--start' );
    } else {
      mvSwiper.autoplay.start();
      mvStop.classList.remove( 'is--start' );
    }
  } );

  /**
   * solutionスライダー
   */
  const solutionSwiper = new Swiper( '.p-home-slide__container', {
    loop: true,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false
    // },
    navigation: {
      nextEl: '.p-home-slide__next',
      prevEl: '.p-home-slide__prev'
    },
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
      1200: {
        slidesPerView: 4,
        spaceBetween: 40
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 40
      }
    },
  } );
}
